<template>
    <div class="service">
        <div class="banner">
            <img src="../assets/ycb/sbanner.png" alt="">
            <div class="text">
                <p class="animated fadeInUp">sheq</p>
                <!-- <p class="animated fadeInUp">{{$t('job').banner}}</p> -->
            </div>
        </div>
        <div class="main">
            <div class="titles">
                <p class="t1 wow fadeInUp">SHEQ</p>
                <p class="t2 wow fadeInUp">{{$t('job').text0}}</p>
                <p class="t3 wow fadeInUp">
                    {{$t('job').text1[0]}}<br>
                    {{$t('job').text1[1]}}<br>
                    {{$t('job').text1[2]}}<br>
                    {{$t('job').text1[3]}}
                </p>
            </div>
            <div class="allItems">
                <div class="item wow fadeInUp" v-for="(item,index) in list" :key="index" @click="gotoInfo(item.id)">
                    <img class="bgImg" :src="`http://www.uni-sec.com/${item.picurl_1}`" alt="">
                    <div class="info">
                        <div class="t1">
                            <div class="l">
                                <img src="../assets/ycb/dun.png" alt="">
                                <p>{{index+1}}</p>
                            </div>
                            <p class="r">{{item.title}}</p>
                        </div>
                        <div class="t2">
                       {{item.description}}
                        </div>
                        <p class="t3">
                            <i class="iconfont icon-xiangyou"></i>
                        </p>
                    </div>
                    <div class="info2">
                        <img :src="`http://www.uni-sec.com/${item.picurl_2}`" alt="">
                        <div class="content">
                            <p class="t1">{{item.title}}</p>
                            <p class="t2">{{item.description}}</p>
                            <div v-html="item.description_2">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import Scrollbar from 'smooth-scrollbar'
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import { getSheq} from '../util/lang'
    export default {
        name: 'about',
        data(){
            return{
                list:[
                    {
                        img:require('../assets/ycb/s.png'),
                        img2:require('../assets/ycb/sss.png'),
                        title:'SAFETY',
                        intro:'Safety is Uni-sec’s first priority. Safety is an integrated part of our daily business. The personal safety and health of all our employees and stakeholders is our greatest responsibility.',
                        content:`
                                ISO9001-2015<br>
Execute Quality, health, safety and environment (QHSE)<br>
Production guidelines<br>
In-house safety training to our staff<br>
Checking all the production equipment periodically
                            `
                    },
                    {
                        img:require('../assets/ycb/sh.png'),
                        img2:require('../assets/ycb/shh.png'),
                        title:'HEALTH',
                        intro:'Safety is Uni-sec’s first priority. Safety is an integrated part of our daily business. The personal safety and health of all our employees and stakeholders is our greatest responsibility.',
                        content:`
                                ISO9001-2015<br>
Execute Quality, health, safety and environment (QHSE)<br>
Production guidelines<br>
In-house safety training to our staff<br>
Checking all the production equipment periodically
                            `
                    },
                    {
                        img:require('../assets/ycb/E.png'),
                        img2:require('../assets/ycb/see.png'),
                        title:'ENVIRONMENT',
                        intro:'Safety is Uni-sec’s first priority. Safety is an integrated part of our daily business. The personal safety and health of all our employees and stakeholders is our greatest responsibility.',
                        content:`
                                ISO9001-2015<br>
Execute Quality, health, safety and environment (QHSE)<br>
Production guidelines<br>
In-house safety training to our staff<br>
Checking all the production equipment periodically
                            `
                    },
                    {
                        img:require('../assets/ycb/q.png'),
                        img2:require('../assets/ycb/sqq.png'),
                        title:'SAFETY',
                        intro:'Safety is Uni-sec’s first priority. Safety is an integrated part of our daily business. The personal safety and health of all our employees and stakeholders is our greatest responsibility.',
                        content:`
                                ISO9001-2015<br>
Execute Quality, health, safety and environment (QHSE)<br>
Production guidelines<br>
In-house safety training to our staff<br>
Checking all the production equipment periodically
                            `
                    }
                ]
            }
        },
        components:{footComponent},
        mounted() {
            Scrollbar.initAll(document.getElementById("scroller-wrapper"));
            this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            this.scrollbar.scrollTo(0,1)
            this.scrollbar.addListener((status) => {
                window.pageYOffset=this.scrollbar.scrollTop
            });
            this.getContent()
        },
        methods:{
            gotoInfo(id){
                const link=`/jobInfo.html?id=${id}`
                window.open(link,'_self')
            },
            getContent(){
                const url = `${getSheq()}`
                this.$axios.get(url).then(res => {
                    this.list=res.data
                    console.log(res.data)
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .service{
        width:100%;
        animation: run5 1s linear forwards;
        position: relative;
        @keyframes run5 {
            from{
                opacity: 0;
            }
            to{
                opacity: 1;
            }
        }
        .banner{
            width:100%;
            position: relative;
            overflow: hidden;
            img{
                display: block;
                width:100%;
                object-fit: cover;
                animation: sbig 2s linear forwards;
            }
            @keyframes sbig {
                from{
                    transform: scale(1);
                    filter: blur(5px);
                }
                to{
                    transform: scale(1.05);
                    filter: blur(0);
                }
            }
            .text{
                position: absolute;
                left:10%;
                bottom:20%;
                width:80%;
                p:nth-child(1){
                    color:white;
                    font-size: 50px;
                    animation-duration: 2s;
                    font-family:"itbook";
                    text-transform: uppercase;
                }
                p:nth-child(2){
                    color:white;
                    font-family: "it";
                    line-height: 30px;
                    animation-duration: 2s;
                    animation-delay: 1s;
                    font-size: 20px;
                    margin-top: 30px;
                }
            }
        }
        .main{
            width:80%;
            margin: 60px auto;
            .titles{
                .t1{
                    color:#263346;
                    font-size: 40px;
                    font-family: "DINEngschriftStd";
                    border-bottom: 1px solid rgba(38,51,70,.2);
                    padding: 20px 0;
                }
                .t2{
                    color:#263346;
                    font-family: "DINEngschriftStd";
                    font-size: 24px;
                    margin: 20px auto;
                }
                .t3{
                    font-family: "it";
                    line-height: 25px;
                    margin: 30px auto;
                }
            }
            .allItems{
                width:100%;
                margin: 60px auto;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                margin-left: -2%;
                .item{
                    width:48%;
                    margin-left: 2%;
                    position: relative;
                    margin-top: 40px;
                    cursor: pointer;
                    .bgImg{
                        width:100%;
                        display: block;
                        object-fit: cover;
                        transition: all 600ms;
                    }
                    .info{
                        position: absolute;
                        left:10%;
                        top:0;
                        width:80%;
                        height:100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        .t1{
                            width:100%;
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            .l{
                                position: relative;
                                p{
                                    position: absolute;
                                    left:0;
                                    top:0;
                                    color:white;
                                    font-size: 14px;
                                    font-family: "DINEngschriftStd";
                                    text-align: center;
                                    width:100%;
                                    height:100%;
                                    line-height: 25px;
                                }
                            }
                            .r{
                                font-size: 24px;
                                color:white;
                                font-family: 'DINEngschriftStd';
                                margin-left:20px;
                            }
                        }
                        .t2{
                            color:white;
                            font-size: 14px;
                            font-family: "it";
                            line-height: 25px;
                            margin: 30px auto;
                            width:100%;
                        }
                        .t3{
                            text-align: right;
                            color:white;
                            width:80%;
                            margin: 0 auto;
                            i{
                                font-size: 30px;
                            }
                        }
                    }
                    .info2{
                        position: absolute;
                        left:0;
                        top:0;
                        width:100%;
                        height:100%;
                        opacity: 0;
                        transition: all 600ms;
                        img{
                            width:100%;
                            height:100%;
                            display: block;
                            object-fit: cover;
                        }
                        .content{
                            position: absolute;
                            width:80%;
                            left:10%;
                            top:0;
                            .t1{
                                font-size: 40px;
                                color:white;
                                font-family: "DINEngschriftStd";
                                text-transform: uppercase;
                                border-bottom: 1px solid rgba(255,255,255,.8);
                                padding: 30px 0;
                                transition: all 1s;
                                opacity: 0;
                                transform: translateY(20px);
                            }
                            .t2{
                                font-size: 14px;
                                font-family: "it";
                                line-height: 24px;
                                margin-top: 20px;
                                color:white;
                                transition: all 1s;
                                opacity: 0;
                                transform: translateY(20px);
                            }
                            div{
                                font-size: 14px;
                                line-height: 25px;
                                font-family: "itbook";
                                color:white;
                                margin-top: 20px;
                                transition: all 1s;
                                opacity: 0;
                                transform: translateY(20px);
                            }
                        }
                    }
                    &:hover{
                        .info2{
                            opacity: 1;
                            .content{
                                .t1,.t2,div{
                                    opacity: 1;
                                    transform: translateY(0);
                                }
                            }
                        }
                    }
                }
            }
        }
        .foot{
            animation-name: polygon;
            animation-duration: 2s;
        }
        @keyframes transition1 {
            0% {
                transform: translate(-300px,-300px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes transition2 {
            0% {
                transform: translate(300px,-300px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes polygon {
            0% {
                clip-path: polygon(100% 0, 99% 50%, 50% 99%,100% 50%);
                opacity: 0;
            }
            100% {
                clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
                opacity: 1;
            }
        }
        @media screen and (max-width: 1440px){
            .main{
                width:90%;
                .ncenter{
                    .allItems{
                        .item{
                            .r{
                                p:nth-child(1){
                                    margin: 10px auto;
                                }
                            }
                        }
                    }
                }
                .allItems{
                    .item{
                        .info2{
                            .content{
                                div{
                                    margin-top: 0;
                                }
                            }
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 1000px){
            .banner{
                img{
                    height:500px;
                }
                .text{
                    bottom:20%;
                    p:nth-child(1){
                        font-size: 30px;
                    }
                    p:nth-child(2){
                        font-size: 16px;
                    }
                }
            }
            .main{
                width:90%;
                margin: 30px auto;
                .titles{
                    .t1{
                        font-size: 20px;
                        padding: 10px 0;
                    }
                    .t2{
                        font-size: 18px;
                        margin: 10px auto;
                    }
                    .t3{
                        margin: 15px auto;
                    }
                }
                .allItems{
                    flex-direction: column;
                    margin: 30px auto;
                    .item{
                        width:100%;
                        margin-left: 0;
                        .bgImg{
                            height:500px;
                        }
                    }
                }
            }
        }
    }
</style>
